"use strict";

Shopify.theme.jsHeader = {
  init: function init($section) {
    var _this = this;

    // Add settings from schema to current object
    Shopify.theme.jsHeader = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

    this.$el = $('#header');
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    var announcementHeight = $('.announcement-sticky-wrapper').height(); // Overlaid header

    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    } // Sticky header 

    this.setMobileHeaderHeightVar.bind(this);
    this.setMobileHeaderHeightVar();

    // if (this.enable_sticky === true && isScreenSizeLarge()) {
    //   this.enableSticky(announcementHeight);
    // } alex


    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', function () {
        this.initSliderBottomBar();
      });
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();

      if (Shopify.theme_settings.announcement_enabled == true) {
        Shopify.theme.jsAnnouncementBar.addVerticalHeaderTopMargin();
      }

      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      Shopify.theme.jsMegaMenu.init($section);
    }

    if (!isScreenSizeLarge()) {
      //this.unload();
      //Shopify.theme.mobileMenu.init();
    }
    Shopify.theme.mobileMenu.init();

    //bottom bar(after navigation) slider

    if ($('.bottom-bar-section').length > 0) {
      this.initSliderBottomBar();
    }

    $('.navbar-item').on('mouseleave', function () {
      Shopify.theme.jsHeader.collapseSubmenu($(this));
    });
    $('.search-overlay__close').on('click', function () {
      Shopify.theme.jsHeader.hideSearch();
    });
    $(document).on('click', '[data-show-search-trigger]', function () {
        //Shopify.theme.jsHeader.showSearch($(this).attr('data-bottom-search'));
        $('.mobile_menu_search .aa-Autocomplete .aa-DetachedSearchButton').click();
    });

    // update sticky state
    $(window).on('load', function () {
      if ( $(window).width() > 768 ) {
        //Shopify.theme.jsHeader.disableSticky();
        //Shopify.theme.jsHeader.enableSticky(announcementHeight);
      } else {
        //Shopify.theme.jsHeader.disableSticky();
        //Shopify.theme.jsHeader.enableSticky();
      }
    });

    var sizeLarge = $(window).width() > 768;
    $(window).on('resize', function () {
      var screenWidth = $(window).width();
      _this.setMobileHeaderHeightVar();
      if ( screenWidth > 768 && !sizeLarge ) {
       // Shopify.theme.mobileMenu.disableSticky();
        Shopify.theme.jsHeader.enableSticky(announcementHeight);
        sizeLarge = true;
      } else if ( screenWidth < 768 && sizeLarge ) {
        //Shopify.theme.jsHeader.disableSticky();
        Shopify.theme.mobileMenu.enableSticky();
        sizeLarge = false;
      }
    });

    $(".check__focus").focusin(function() {
      $(".check__focus").parent().addClass('is-focused');
    });
    $(".check__focus").focusout(function() {
      $(".check__focus").parent().removeClass('is-focused');
    });

    // header login toggle
    $('.header_account_trigger').on('click', function(e){
      // if ( $(window).width() > 768 ) {
        e.preventDefault();
        $(this).toggleClass('active');

        var $divElement = $('.header_account_trigger');
        $(".mobile-menu").on('scroll', function(event) {
          // Check if the clicked element is inside the div element
          if (!$divElement.is(event.target) && !$divElement.has(event.target).length) {
            console.log("HERE 2 ")
            // Check if the div element is active
            if ($divElement.hasClass('active')) {
              // Remove the "active" class from the div element
              $divElement.removeClass('active');
              $('.header_account_dropdown').hide();
            }
          }
        });
        $(document).on('scroll', function(event) {

          // Check if the clicked element is inside the div element
          if (!$divElement.is(event.target) && !$divElement.has(event.target).length) {
            console.log("HERE 2 ")
            // Check if the div element is active
            if ($divElement.hasClass('active')) {
            
              // Remove the "active" class from the div element
              $divElement.removeClass('active');
              $('.header_account_dropdown').hide();
            }
          }
        });
      
        $('.header_account_dropdown').slideToggle(300);
      // }
    });
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.header_account_dropdown').length && !$(e.target).closest('.header_account_trigger').length) {
        $('.header_account_dropdown').slideUp(300).removeClass('recovery_form');
        $('.header_account_trigger').removeClass('active');
        
      }
      e.stopPropagation();
    });
    $('.js-recover-password_header').on('click', function(e){
      $('.header_account_dropdown').addClass('recovery_form');
    });
    $('.cancel-recover-password-header').on('click', function(e){
      $('.header_account_dropdown').removeClass('recovery_form');
    });



    $(document).on('focus', '#boost-pfs-search-box-mobile', function () {
      $(document.body).addClass('mobile_search_focus');
    });
    $(document).on('blur', '#boost-pfs-search-box-mobile', function () {
      $(document.body).removeClass('mobile_search_focus');
    });
    // $('.boost-pfs-search-box').on('blur', function (e) {
    //   $('body').removeClass('mobile_search_focus');
    // });
  },
  collapseSubmenu: function collapseSubmenu(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  initSliderBottomBar: function initSliderBottomBar() {

    var $slider = $('[data-init-slider-header-bottom]');
    var isFlickity = false;
    initSldier();

    function initSldier() {

      if ($(window).width() < 800) {
        if (!isFlickity) {
        $slider.flickity({
          // options
          cellAlign: 'center',
          pageDots: false,
          groupCells: true,
          prevNextButtons: false,
          freeScroll: true,
          wrapAround: true, 
          fade: true,
          autoPlay: 4000 
          
        });
       }
        isFlickity = true;
      }
      else {
        if (isFlickity) {
            $slider.flickity('destroy');
         }
        isFlickity = false;
      }
    }

    $(window).resize(function () {
      initSldier();
    });
  },
  showStickyMenu: function showStickyMenu() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function hideStickyMenu() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function disableSticky() {
    // var $stickyEl = $('#header');
    // $stickyEl.unstick();
    // $stickyEl.removeClass('sticky--enabled');
    // setTimeout(function () {
    //   $stickyEl.css('height', 'auto');
    // }, 250);
  },
  enableSticky: function enableSticky(offset) {
    // var _this2 = this;

    // var $stickyEl = this.$el;
    // $stickyEl.addClass('sticky--enabled');
    // $stickyEl.sticky({
    //   wrapperClassName: 'header-sticky-wrapper',
    //   zIndex: 40,
    //   topSpacing: offset || 0
    // }).on('sticky-start', function () {
    //   var headerHeight;
    //   var announcementHeight; // Hide the mini cart for centered header layout

    //   if (Shopify.theme_settings.header_layout == 'centered') {
    //     $('[data-ajax-cart-trigger]').removeClass('show-mini-cart');
    //   } // Get header height is sticky enabled


    //   if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
    //     headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
    //   } // Get announcement height is sticky enabled


    //   if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
    //     announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    //   }

    //   var totalHeight = headerHeight + announcementHeight;
    //   $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

    //   if (_this2.enable_overlay === true && _this2.sectionUnderlayIsImage() === true) {
    //     $stickyEl.parent().addClass('has-overlaid-header');

    //     _this2.disableOverlayStyle();
    //   } else if (_this2.enable_overlay === true) {
    //     _this2.disableOverlayStyle();
    //   }
    // }).on('sticky-end', function () {
    //   $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%'); // Safety timeout for logo width transition which can throw calculated height off

    //   setTimeout(function () {
    //     $stickyEl.sticky('update');
    //   }, 250);

    //   _this2.$el.find('.sticky-menu-wrapper').removeClass('is-visible');

    //   _this2.$menuToggle.removeClass('is-active');

    //   if (_this2.enable_overlay === true && _this2.sectionUnderlayIsImage() === true) {
    //     _this2.updateOverlayStyle(_this2.sectionUnderlayIsImage());
    //   }
    // });
  },
  disableOverlayStyle: function disableOverlayStyle() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function enableOverlayStyle() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function updateOverlayStyle(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function sectionUnderlayIsImage() {
    var $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first(); // Check whether the first element has class to indicate it should be under header when overlay is enabled

    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }
  },
  showSearch: function showSearch(bottom) {
    // $('[data-show-search-trigger]').addClass('is-active');
    // $('body').toggleClass('search-active');
    // if (bottom && !document.body.classList.contains('search-bottom') && document.body.classList.contains('search-active') ) {
    //   $('body').addClass('search-bottom');
    // } else {
    //   $('body').removeClass('search-bottom');
    // }

    if (Shopify.theme_settings.search_layout == 'overlay') {
      // $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').toggleClass('is-opened');
      $('.search-form .search__fields input[type="text"]').focus();
    } else {

      var $input = $('.mobile-header__custom-search [name="q"]')
      $input.focus();
      $input.val($input.val())

      // $.fancybox.open($('.js-search-popup'), {
      //   baseClass: 'search__lightbox',
      //   hash: false,
      //   infobar: false,
      //   toolbar: false,
      //   loop: true,
      //   smallBtn: true,
      //   mobile: {
      //     preventCaptionOverlap: false,
      //     toolbar: false
      //   },
      //   beforeClose: function beforeClose() {
      //     $('[data-show-search-trigger]').removeClass('is-active');
      //   }
      // });
    }
  },
  hideSearch: function hideSearch() {
    $('[data-show-search-trigger]').removeClass('is-active');
    // $('body').removeClass('search-active');
    $('body').removeClass('search-bottom');

    if (Shopify.theme_settings.search_layout == 'overlay') {
      // $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').removeClass('is-opened');
    } else {
      $.fancybox.close($('[data-search-type="' + Shopify.theme_settings.search_layout + '"]'));
    }
  },
  addOffScreenDropdownCheck: function addOffScreenDropdownCheck() {
    $('.navbar-item.has-dropdown--vertical').hover(function () {
      var dropdown = $(this),
          menu = dropdown.find('.navbar-dropdown');
      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }
    });
  },
  getHeaderHeight: function getHeaderHeight() {
    var headerHeight = $('.header-section').outerHeight() || 0;
    return headerHeight;
  },
  setMobileHeaderHeightVar: function getHeaderHeight() {
    var sizeProp = '--mobile-header-height:'
    var headerHeight = $('#mobile-header').outerHeight() || 0;
    var styles =$('html').attr('style').split(';').filter(Boolean);
    var index = styles.findIndex(style => style.includes(sizeProp))
    var size = ` ${sizeProp} ${headerHeight}px`

    if (index < 0) styles.push(size)
    else styles[index] = size
    $('html').attr('style', `${styles.join(';')};`);
  },
  unload: function unload($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('.search-overlay__close, [data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  }
};
